// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"190":"959513f3","311":"31cca952","360":"511eaf5e","661":"21515b58","672":"af94ea4a","794":"a4ab5ffe","853":"f8499572","860":"16b02fc8","985":"a05ec17f"}[chunkId] + ".chunk.css";
};